var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import getAPIMap from "../api_map.js";
import axios from "axios";
import { whatsAppTopCampaigns } from "../reports_data.js";
import { customDateStartUTCTimeZone, customDateEndUTCTimeZone, customDateStartUTCTimeZoneZ, customDateEndUTCTimeZoneZ, getTimeZoneInHours, customDateStartWithoutTz, customDateEndWitoutTz, customDateFormatStartAndEnd, } from "../utils/DateOrdinals.js";
import getIP from "../getIP.js";
var IP = getIP();
import dayjs from "dayjs";
import { tableDetails } from "constants_map.js";
var interfaceTypeMapping = {
    volumetricsPanel: "",
    smsVolumetricsPanel: "API",
    smppVolumetricsPanel: "SMPP",
    cmpgnMsgData: "WEB",
    ftpVolumetricsPanel: "FTP",
    emailVolumetricsPanel: "",
};
var waInterfaceMapping = {
    volumetricsPanel: "",
    smsVolumetricsPanel: "1",
    smppVolumetricsPanel: "3",
    cmpgnMsgData: "0",
    ftpVolumetricsPanel: "2",
};
var getPerformancePie = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, category, channel, direction, convType, urlMap, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                category = "";
                channel = "";
                direction = "";
                convType = "";
                if (queryKey[5] === "All Channels") {
                    channel = queryKey[4]
                        ? queryKey[4] === "Voice"
                            ? "&pr_tp=Voice"
                            : queryKey[4] === "Virtual Receptionist"
                                ? "&pr_tp=VR"
                                : ""
                        : "";
                    direction = queryKey[4] && queryKey[4] === "WhatsApp" ? "&dir=0" : "";
                }
                else {
                    category =
                        queryKey[4] || queryKey[4] === 0
                            ? queryKey[5] === "Virtual Receptionist" || queryKey[5] === "Voice"
                                ? "&direction=".concat(queryKey[4])
                                : queryKey[6] !== "RCSPerfPie"
                                    ? "&m_ctg=".concat(queryKey[4])
                                    : ""
                            : "";
                    channel = queryKey[5]
                        ? queryKey[5] === "Voice"
                            ? "&pr_tp=Voice"
                            : queryKey[5] === "Virtual Receptionist"
                                ? "&pr_tp=VR"
                                : ""
                        : "";
                    direction = queryKey[5] && queryKey[5] === "WhatsApp" ? "&dir=0" : "";
                    if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
                        fDate = queryKey[2]
                            ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                            : "";
                        tDate = queryKey[3]
                            ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                            : "";
                    }
                    if (queryKey[5] === "RCS" && queryKey[6] === "RCSPerfPie") {
                        convType =
                            queryKey[4] !== "" && queryKey[4] !== undefined && queryKey[4] !== null
                                ? "&m_tp=".concat(queryKey[4])
                                : "";
                    }
                }
                urlMap = {
                    Voice: "getVoicePerformancePie",
                    "Virtual Receptionist": "getVoicePerformancePie",
                    SMS: "getPerformancePie",
                    WhatsApp: "getWAVolumetricsPanel",
                    Email: "getEmailPerformancePie",
                    RCS: "getRcsStatusTrendGraph",
                };
                url = "".concat(IP).concat(getAPIMap(urlMap[queryKey[5]] ? urlMap[queryKey[5]] : urlMap[queryKey[4]])).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(channel).concat(direction).concat(convType);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getInterfacePie = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, waOption, urlMapping, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[5]
                    ? queryKey[5] === "Voice"
                        ? "&pr_tp=Voice"
                        : queryKey[5] === "Virtual Receptionist"
                            ? "&pr_tp=VR"
                            : ""
                    : "";
                waOption = queryKey[5] === "WhatsApp" ? "&category=i_tp" : "";
                if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
                    fDate = queryKey[2]
                        ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                        : "";
                    tDate = queryKey[3]
                        ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                        : "";
                }
                urlMapping = {
                    Voice: "getVoiceInterfacePie",
                    "Virtual Receptionist": "getVoiceInterfacePie",
                    WhatsApp: "getWAVolumetricsPanel",
                    SMS: "getInterfacePie",
                    Email: "getInterfacePieEmail",
                };
                url = "".concat(IP).concat(getAPIMap(urlMapping[queryKey[5]])).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel).concat(waOption);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getSummaryPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getSummaryPanel") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWASummaryPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                tDate = queryKey[3]
                    ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWAVolumetricsPanel") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllEmailVolPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getAllEmailVolPanel") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getEmailVolumetricsPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, interfaceTypeMappingEmail, fDate, tDate, iType, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                interfaceTypeMappingEmail = {
                    emailVolumetricsPanel: "",
                    emailVolumetricsPanelWeb: "WEB",
                    emailVolumetricsPanelApi: "API",
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                iType = interfaceTypeMappingEmail[queryKey[0]] &&
                    "i_tp=".concat(interfaceTypeMappingEmail[queryKey[0]]);
                url = IP +
                    getAPIMap("getVolumetricsPanelEmail") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(iType ? "&".concat(iType) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getVolumetricsPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, iType, channel, category, direction, urlMap, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                iType = "";
                channel = "";
                category = "";
                direction = "";
                if (queryKey[5] === "All Channels") {
                    iType =
                        queryKey[4] === "Voice" || queryKey[4] === "Virtual Receptionist"
                            ? ""
                            : interfaceTypeMapping[queryKey[0]] &&
                                "&i_tp=".concat(interfaceTypeMapping[queryKey[0]]);
                    channel = queryKey[4]
                        ? queryKey[4] === "Voice"
                            ? "&pr_tp=Voice"
                            : queryKey[4] === "Virtual Receptionist"
                                ? "&pr_tp=VR"
                                : ""
                        : "";
                }
                else {
                    // Not all channels
                    iType =
                        queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                            ? ""
                            : interfaceTypeMapping[queryKey[0]] &&
                                "&i_tp=".concat(interfaceTypeMapping[queryKey[0]]);
                    channel = queryKey[5]
                        ? queryKey[5] === "Voice"
                            ? "&pr_tp=Voice"
                            : queryKey[5] === "Virtual Receptionist"
                                ? "&pr_tp=VR"
                                : ""
                        : "";
                    category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                }
                if (queryKey[5] === "WhatsApp" ||
                    (queryKey[5] === "All Channels" &&
                        (queryKey[4] === "WhatsApp" ||
                            queryKey[4] === "SMS" ||
                            queryKey[4] === "Email"))) {
                    fDate = queryKey[2]
                        ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                        : "";
                    tDate = queryKey[3]
                        ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3].includes("%")
                            ? queryKey[3].split("%")[0] + "Z"
                            : queryKey[3]))
                        : "";
                    iType =
                        waInterfaceMapping[queryKey[0]] &&
                            "&i_tp=".concat(waInterfaceMapping[queryKey[0]]);
                    direction = "&dir=0";
                }
                urlMap = {
                    Voice: "getVoiceVolumetricsPanel",
                    "Virtual Receptionist": "getVoiceVolumetricsPanel",
                    SMS: "getVolumetricsPanel",
                    WhatsApp: "getWAVolumetricsPanel",
                    Email: "getVolumetricsPanelEmail",
                };
                url = "".concat(IP).concat(getAPIMap(urlMap[queryKey[5]]
                    ? urlMap[queryKey[5]]
                    : urlMap[queryKey[4]]
                        ? urlMap[queryKey[4]]
                        : urlMap[queryKey[6]]
                            ? urlMap[queryKey[6]]
                            : urlMap["SMS"])).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(channel).concat(iType).concat(direction);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getVoiceVolumetricsPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = "".concat(IP).concat(getAPIMap("getVoiceVolumetricsPanel")).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getApiCallsPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, category, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                channel = queryKey[5]
                    ? queryKey[5] === "Voice"
                        ? "&pr_tp=Voice&i_tp=API"
                        : queryKey[5] === "Virtual Receptionist"
                            ? "&pr_tp=VR"
                            : ""
                    : "";
                if (queryKey[5] && queryKey[5] === "WhatsApp") {
                    fDate = queryKey[2]
                        ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                        : "";
                    tDate = queryKey[3]
                        ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                        : "";
                }
                url = "".concat(IP).concat(getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                    ? "getVoiceVolumetricsPanel"
                    : queryKey[5] === "WhatsApp"
                        ? "getWAVolumetricsPanel"
                        : "getVolumetricsPanel")).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getStatusTrendGraph = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, urlMap, apiUrl, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                console.log("calling api");
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2],
                        tDate: queryKey[3],
                    },
                };
                if (queryKey[4] || queryKey[4] === 0) {
                    if (queryKey[5] === "Virtual Receptionist") {
                        config.params.direction = queryKey[4];
                    }
                    else {
                        config.params.m_ctg = queryKey[4];
                    }
                }
                if (queryKey[5]) {
                    if (queryKey[5] === "Voice") {
                        config.params.pr_tp = "Voice";
                    }
                    else if (queryKey[5] === "Virtual Receptionist") {
                        config.params.pr_tp = "VR";
                    }
                }
                if (queryKey[5] === "WhatsApp") {
                    config.params.timeRange = "dayOfYear";
                    config.params.timeZone = getTimeZoneInHours().replace("%2B", "+");
                }
                urlMap = {
                    Voice: "getVoiceStatusTrendGraph",
                    "Virtual Receptionist": "getVoiceStatusTrendGraph",
                    Email: "getEmailStatusTrendGraph",
                    RCS: "getRcsStatusTrendGraph",
                    WhatsApp: "getWaTrafficAnalysisGraph",
                    SMS: "getStatusTrendGraph",
                    default: "getTrafficAnalysis",
                };
                apiUrl = "";
                if (urlMap[queryKey[5]]) {
                    apiUrl = urlMap[queryKey[5]];
                }
                else {
                    console.log("[ERROR] getStatusTrendGraph: Unknown Channel: ".concat(queryKey[5]));
                    apiUrl = urlMap.default;
                }
                console.log("apiUrl:", apiUrl);
                url = "".concat(IP).concat(getAPIMap(apiUrl));
                console.log("url:", url);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                console.log("response:", response);
                return [2 /*return*/, response];
        }
    });
}); };
var getNumbersPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, capabilities, category, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                capabilities = queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                    ? "&capabilities=voice"
                    : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                url = IP +
                    getAPIMap("getNumbersPanel") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(capabilities);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getNumberPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, capabilities, category, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                tDate = queryKey[3]
                    ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                capabilities = queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                    ? "&capabilities=voice"
                    : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                url = IP +
                    getAPIMap("getNumberPanel") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(capabilities);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getSenderPie = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, category, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "fDate=".concat(queryKey[2])
                    : "";
                tDate = queryKey[3]
                    ? "tDate=".concat(queryKey[3])
                    : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                url = IP +
                    getAPIMap("getSenderPie") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getRevenueTrendEmail = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, type, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                type = queryKey[0] === "getRevenuePieEmail"
                    ? "&type=pie"
                    : queryKey[0] === "getEmailRevenueTrend"
                        ? "&type=trend"
                        : "";
                url = IP +
                    getAPIMap("getRevenueTrendEmail") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(type);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getSummaryRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, category, type, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                type = queryKey[0] === "revenuePie"
                    ? "&type=pie"
                    : queryKey[0] === "usageTrend"
                        ? "&type=trend"
                        : "";
                url = IP +
                    getAPIMap("getSummaryRevenue") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(type);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getEmailMetrics = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, category, type, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "startDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "endDate=".concat(queryKey[3]) : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                type = queryKey[0] === "revenuePie"
                    ? "&type=pie"
                    : queryKey[0] === "usageTrend"
                        ? "&type=trend"
                        : "";
                url = IP +
                    getAPIMap("getEmailMetrics") +
                    "".concat(startDate && endDate ? "?".concat(startDate, "&").concat(endDate) : "").concat(category).concat(type);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getSummaryRevenueForVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getSummaryRevenueForVoice") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getCampaignRevenueForVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, category, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                category = queryKey[4] === "Voice"
                    ? "&pr_tp=Voice"
                    : queryKey[4] === "Virtual Receptionist"
                        ? "&pr_tp=VR"
                        : "";
                url = IP +
                    getAPIMap("getCampaignRevenueForVoice") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getCampaignRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2])) : "";
                tDate = queryKey[3] ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3])) : "";
                channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
                    ? "&channel=".concat(queryKey[4])
                    : "";
                url = IP +
                    getAPIMap("getCampaignRevenue") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllEmailCampaignRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
                    ? "&channel=".concat(queryKey[4])
                    : "";
                url = IP +
                    getAPIMap("getAllEmailCampaignRevenue") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTopPackages = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, urlMapping, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[5] && queryKey[5] !== "All Channels" && queryKey[5] !== "All"
                    ? "&channel=".concat(queryKey[5])
                    : queryKey[4]
                        ? "&channel=".concat(queryKey[4])
                        : "";
                url = "";
                if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
                    fDate = queryKey[2]
                        ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                        : "";
                    tDate = queryKey[3]
                        ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                        : "";
                }
                urlMapping = {
                    Voice: "getTopPackagesForVoice",
                    WhatsApp: "getTopPackagesForWA",
                    SMS: "getTopPackages",
                    Email: "getTopPackagesForEmail",
                    RCS: "getTopPackagesForRcs",
                };
                url =
                    IP +
                        getAPIMap(urlMapping[queryKey[5]]
                            ? urlMapping[queryKey[5]]
                            : urlMapping[queryKey[4]]) +
                        "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTopPackagesForVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
                    ? "&channel=".concat(queryKey[4])
                    : "";
                url = IP +
                    getAPIMap("getTopPackagesForVoice") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTopPackagesForEmail = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
                    ? "&channel=".concat(queryKey[4])
                    : "";
                url = IP +
                    getAPIMap("getTopPackagesForEmail") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTopEnterprises = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, urlMapping, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[5] && queryKey[5] !== "All Channels" && queryKey[5] !== "All"
                    ? "&channel=".concat(queryKey[5])
                    : queryKey[4]
                        ? "&channel=".concat(queryKey[4])
                        : "";
                url = "";
                if (queryKey[5] && (queryKey[5] === "WhatsApp" || queryKey[5] === "SMS")) {
                    fDate = queryKey[2]
                        ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                        : "";
                    tDate = queryKey[3]
                        ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3].split("%")[0]))
                        : "";
                }
                urlMapping = {
                    Voice: "getTopEnterprisesForVoice",
                    WhatsApp: "getTopEnterprisesForWA",
                    SMS: "getTopEnterprises",
                    Email: "getTopEnterprisesForEmail",
                    RCS: "getTopEnterprisesForRcs",
                };
                url =
                    IP +
                        getAPIMap(urlMapping[queryKey[5]]
                            ? urlMapping[queryKey[5]]
                            : urlMapping[queryKey[4]]) +
                        "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTopEnterprisesforVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
                    ? "&channel=".concat(queryKey[4])
                    : "";
                url = IP +
                    getAPIMap("getTopEnterprisesForVoice") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTopEnterprisesForEmail = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[4] && queryKey[4] !== "All Channels" && queryKey[4] !== "All"
                    ? "&channel=".concat(queryKey[4])
                    : "";
                url = IP +
                    getAPIMap("getTopEnterprisesForEmail") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getNumberInventoryStatusPanel = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = {
            revenue: "0",
            totalNumbers: "0",
            otc: "0",
            mrc: "0",
            totalInventory: "0",
            totalPurchased: "0",
        };
        return [2 /*return*/, data];
    });
}); };
var getNumberConfigurationPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getNumberConfigurationPanel") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getCampaignsPanel = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        data = {
            revenue: "0",
            totalCamp: "0",
            scheduled: "0",
            completed: "0",
            inProgress: "0",
            paused: "0",
            failed: "0",
        };
        return [2 /*return*/, data];
    });
}); };
var getSmsCampaignPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                tDate = queryKey[3]
                    ? "enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP +
                    getAPIMap("getSmsCampaignPanel") +
                    "?pgsize=1&pgindex=1".concat(fDate && tDate ? "&".concat(fDate, "&").concat(tDate, "&duration=CUSTOM&channels=sms") : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getCampaignCallsPanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, category, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                channel = queryKey[5]
                    ? queryKey[5] === "Voice"
                        ? "&pr_tp=Voice&i_tp=WEB"
                        : queryKey[5] === "Virtual Receptionist"
                            ? "&pr_tp=VR&i_tp=WEB"
                            : ""
                    : "";
                url = "".concat(IP).concat(getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                    ? "getVoiceVolumetricsPanel"
                    : "getVolumetricsPanel")).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(category).concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAccountCount = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var _c;
    var queryKey = _b.queryKey;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "&startDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&endDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("enterprisePaginationApi") +
                    "?pgsize=".concat(10000, "&pgindex=").concat(1).concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _d.sent();
                return [2 /*return*/, ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.count) || 0];
        }
    });
}); };
var getUsersCount = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var _c;
    var queryKey = _b.queryKey;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] || queryKey[2] === "0" ? "&startDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] || queryKey[3] === "0" ? "&endDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getuser") +
                    "?pgsize=".concat(1, "&pgindex=").concat(1).concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _d.sent();
                return [2 /*return*/, (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.totalUsers];
        }
    });
}); };
var getVolumetricsPanelForOutbound = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[5]
                    ? queryKey[5] === "Voice"
                        ? "&pr_tp=Voice&i_tp=API"
                        : queryKey[5] === "Virtual Receptionist"
                            ? "&pr_tp=VR&direction=outbound"
                            : ""
                    : "";
                url = "".concat(IP).concat(getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                    ? "getVoiceVolumetricsPanel"
                    : "getVolumetricsPanel")).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getVolumetricsPanelForInbound = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                channel = queryKey[5]
                    ? queryKey[5] === "Voice"
                        ? "&pr_tp=Voice&i_tp=API"
                        : queryKey[5] === "Virtual Receptionist"
                            ? "&pr_tp=VR&direction=inbound"
                            : ""
                    : "";
                url = "".concat(IP).concat(getAPIMap(queryKey[5] === "Voice" || queryKey[5] === "Virtual Receptionist"
                    ? "getVoiceVolumetricsPanel"
                    : "getVolumetricsPanel")).concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "").concat(channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getMessageTemplatePie = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                url = IP +
                    getAPIMap("getTemplates");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getEmailTemplatePie = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                url = IP + getAPIMap("getTemplatesEmail");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getSchedulingTypePie = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, channel, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] || queryKey[2] === "0" ? "&stdt=".concat(queryKey[2]) : "";
                endDate = queryKey[3] || queryKey[3] === "0" ? "&enddt=".concat(queryKey[3]) : "";
                channel = queryKey[4] ? "&channels=".concat(queryKey[4]) : "";
                url = IP +
                    getAPIMap("getSchedulingTypePie") +
                    "?pgsize=".concat(1, "&pgindex=").concat(0).concat(startDate).concat(endDate, "&duration=CUSTOM").concat(channel);
                url = url.replace("{channel}", channel);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTPSConsumption = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "?fDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&tDate=".concat(queryKey[3]) : "";
                url = IP + getAPIMap("getTPSConsumption") + "".concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getEmailCampaigns = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                tDate = queryKey[3]
                    ? "&enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP + getAPIMap("getEmailCampaigns") +
                    "?".concat(fDate && tDate ? "".concat(fDate).concat(tDate, "&duration=CUSTOM") : "", "&channels=email");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getConcurrentCalls = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "?fDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&tDate=".concat(queryKey[3]) : "";
                url = IP + getAPIMap("concurrentCalls") + "".concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppCampaigns = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "stdt=".concat(customDateStartWithoutTz(queryKey[2]))
                    : "";
                tDate = queryKey[3]
                    ? "enddt=".concat(customDateEndWitoutTz(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWhatsAppCampaigns") +
                    "?pgsize=1&pgindex=1".concat(fDate && tDate
                        ? "&".concat(fDate, "&").concat(tDate, "&duration=CUSTOM&channels=whatsapp")
                        : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppCampaignMessage = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, iType, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                iType = "&i_tp=0";
                url = IP + getAPIMap("getWAVolumetricsPanel") + "".concat(startDate).concat(endDate).concat(iType);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppTopCampaigns = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        config = {
            headers: {
                Authorization: "Bearer ".concat(queryKey[1]),
            },
        };
        startDate = queryKey[2]
            ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
            : "";
        endDate = queryKey[3]
            ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
            : "";
        url = IP + getAPIMap("getWhatsAppCampaignMessage") + "".concat(startDate).concat(endDate);
        response = {
            data: whatsAppTopCampaigns,
        };
        return [2 /*return*/, response];
    });
}); };
var getWhatsAppMessageType = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWAVolumetricsPanel") +
                    "".concat(startDate).concat(endDate, "&category=dir");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppTemplates = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP + getAPIMap("getWATemplates") + "".concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppCampaignRevenueData = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP + getAPIMap("getWhatsAppRevenueData") + "".concat(startDate).concat(endDate, "&category=campaign");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppRevenueData = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWhatsAppRevenueData") +
                    "".concat(startDate).concat(endDate, "&category=m_ctg");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppTemplateTypes = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWAVolumetricsPanel") +
                    "".concat(startDate).concat(endDate, "&category=m_ctg");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppScheduleType = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                endDate = queryKey[3]
                    ? "enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP +
                    getAPIMap("getWAScheduleType") +
                    "?pgsize=".concat(1, "&pgindex=").concat(0, "&").concat(startDate, "&").concat(endDate, "&duration=CUSTOM&channels=whatsapp");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppMessageTypeTrend = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWAVolumetricsPanel") +
                    "".concat(startDate).concat(endDate, "&category=dir&timeRange=dayOfYear");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppRevenueTrend = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, timeZone, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                timeZone = getTimeZoneInHours();
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWhatsAppRevenueData") +
                    "".concat(startDate).concat(endDate, "&category=m_ctg&timeRange=dayOfYear&timeZone=").concat(timeZone);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppStatusTrend = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var timeZone, config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                timeZone = getTimeZoneInHours();
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP +
                    getAPIMap("getWAVolumetricsPanel") +
                    "".concat(startDate).concat(endDate, "&category=free&timeRange=dayOfYear&timeZone=").concat(timeZone);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppTotalRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2]
                    ? "?fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                endDate = queryKey[3]
                    ? "&tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                url = IP + getAPIMap("getWhatsAppRevenueData") + "".concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
// const getEmailCampaignMessage = async ({ queryKey }) => {
//   const config = {
//     headers: {
//       Authorization: `Bearer ${queryKey[1]}`,
//     },
//   };
//   const startDate = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
//   const endDate = queryKey[3] ? `&tDate=${queryKey[3]}` : "";
//   // const startDate1 = queryKey[2] ? `?fDate=${queryKey[2]}` : "";
//   var url =
//     IP + getAPIMap("getEMAILVolumetricsPanel") + `${startDate}${endDate}`;
//   let response = await axios.get(url, config);
//   return response;
// };
var getEmailScheduleType = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "&stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                tDate = queryKey[3]
                    ? "&enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP + getAPIMap("getEmailScheduleType") +
                    "?pgsize=1&pgindex=0" +
                    "".concat(fDate && tDate ? "".concat(fDate).concat(tDate, "&duration=CUSTOM") : "", "&channels=email");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getEmailRevenueTrend = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "?fDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getEmailRevenueData") +
                    "".concat(startDate).concat(endDate, "&category=dir,m_ctg&timeRange=dayofyear");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getEmailStatusTrend = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "?fDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getEMAILVolumetricsPanel") +
                    "".concat(startDate).concat(endDate, "&category=m_ctg&timeRange=dayofyear");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTotalCampaignsCountForVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "&stdt=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "&enddt=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("totalCampaignsCountForVoice") +
                    "?pgsize=1&pgindex=1&srctype=0" +
                    "".concat(fDate && tDate ? "".concat(fDate).concat(tDate, "&duration=CUSTOM") : "", "&channels=voice");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTotalCampaignsCountForVoiceForApiHits = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "&stdt=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "&enddt=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("totalCampaignsCountForVoice") +
                    "?pgsize=1&pgindex=1&srctype=1" +
                    "".concat(fDate && tDate ? "".concat(fDate).concat(tDate, "&duration=CUSTOM") : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getRevenueDataForVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "&fDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("revenueDataForVoice") +
                    "?pgsize=1&pgindex=1&type=pie" +
                    "".concat(startDate).concat(endDate);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getRevenueTrendDataForVoice = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, startDate, endDate, category, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                startDate = queryKey[2] ? "&fDate=".concat(queryKey[2]) : "";
                endDate = queryKey[3] ? "&tDate=".concat(queryKey[3]) : "";
                category = queryKey[4] || queryKey[4] === 0 ? "&m_ctg=".concat(queryKey[4]) : "";
                url = IP +
                    getAPIMap("revenueTrendDataForVoice") +
                    "?pgsize=1&pgindex=1&type=trend" +
                    "".concat(startDate).concat(endDate).concat(category);
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsAppInboundSummary = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, direction, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "fDate=".concat(customDateStartUTCTimeZoneZ(queryKey[2]))
                    : "";
                tDate = queryKey[3]
                    ? "tDate=".concat(customDateEndUTCTimeZoneZ(queryKey[3]))
                    : "";
                direction = "&dir=1";
                url = IP +
                    getAPIMap("getWAVolumetricsPanel") +
                    "?".concat(fDate && tDate ? "".concat(fDate, "&").concat(tDate, "&dir=1") : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllRcsCampaignRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getRcsCampaignRevenue") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllRcsTotalRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getRcsTotalRevenue") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllRcsScheduledCampaign = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                tDate = queryKey[3]
                    ? "enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP +
                    getAPIMap("getRcsScheduledCampaign") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate, "&duration=CUSTOM&channels=rcs") : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllRcsCampaignStatus = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                tDate = queryKey[3]
                    ? "enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP +
                    getAPIMap("getRcsCampaignStatus") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate, "&duration=CUSTOM&channels=rcs") : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllRcsMessageType = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2]
                    ? "stdt=".concat(dayjs(queryKey[2]).format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                tDate = queryKey[3]
                    ? "enddt=".concat(dayjs(queryKey[3])
                        .subtract(1, "day")
                        .format("YYYY-MM-DD"), " ").concat(dayjs().format("HH:mm:ss"))
                    : "";
                url = IP +
                    getAPIMap("getRcsMessageType") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAllRcsSummarypanel = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getSummarypanelForRcs") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getTemplateDistribution = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var token, fromDate, toDate, status, category, config, params, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                token = queryKey[1], fromDate = queryKey[2], toDate = queryKey[3], status = queryKey[4], category = queryKey[5];
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                };
                params = [
                    fromDate && "fDate=".concat(customDateStartUTCTimeZoneZ(fromDate)),
                    toDate && "tDate=".concat(customDateEndUTCTimeZoneZ(toDate)),
                    category && "category=".concat(category),
                    status && "status=".concat(status),
                ]
                    .filter(Boolean)
                    .join("&");
                url = "".concat(IP).concat(getAPIMap("getWaTemplatesList")).concat(params ? "?".concat(params) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWAABusinessNumCounter = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var token, fromDate, toDate, config, params, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                token = queryKey[1], fromDate = queryKey[2], toDate = queryKey[3];
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                };
                params = [
                    fromDate && "fDate=".concat(customDateStartUTCTimeZoneZ(fromDate)),
                    toDate && "tDate=".concat(customDateEndUTCTimeZoneZ(toDate)),
                ]
                    .filter(Boolean)
                    .join("&");
                url = "".concat(IP).concat(getAPIMap("getClients")).concat(params ? "?".concat(params) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWAATemplateAnalyticsApi = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var token, fromDate, toDate, tempId, config, params, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                token = queryKey[1], fromDate = queryKey[2], toDate = queryKey[3], tempId = queryKey[4];
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                };
                params = [
                    fromDate && "start=".concat(customDateStartUTCTimeZoneZ(fromDate)),
                    toDate && "end=".concat(customDateEndUTCTimeZoneZ(toDate)),
                ]
                    .filter(Boolean)
                    .join("&");
                url = "".concat(IP).concat(getAPIMap("getWAATemplateAnalyticsData")).concat(tempId).concat(params ? "?".concat(params) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getWhatsappTemplateList = function (token, prevOptions, pgIndex, search) { return __awaiter(void 0, void 0, void 0, function () {
    var config, url, response, data, total, templatesOptions;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(token),
                    },
                };
                url = "".concat(IP).concat(getAPIMap("getWaTemplatesList"), "?pgSize=").concat(tableDetails.pageSize, "&pgIndex=").concat(pgIndex, "&status=").concat("approved").concat(search !== "" ? "&search=".concat(search) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                data = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || [];
                total = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.totalCount;
                templatesOptions = data === null || data === void 0 ? void 0 : data.map(function (e) { return ({
                    value: e.template_id,
                    label: e.template_name,
                }); });
                // if (pgIndex === 1) {
                //   templatesOptions.unshift({ label: "All", value: "all" });
                // }
                return [2 /*return*/, {
                        options: templatesOptions,
                        hasMore: Math.ceil(total / tableDetails.pageSize) > pgIndex, //data.length === 10,
                        additional: {
                            page: pgIndex + 1,
                        },
                    }];
        }
    });
}); };
export var getTrafficFlowAnalysis = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? queryKey[2] : "",
                        tDate: queryKey[3] ? queryKey[3] : "",
                    },
                };
                url = "".concat(IP).concat(getAPIMap("getTrafficFlowAnalysis"));
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getTrafficAnalysis = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? queryKey[2] : "",
                        tDate: queryKey[3] ? queryKey[3] : "",
                    },
                };
                url = "".concat(IP).concat(getAPIMap("getTrafficAnalysis"));
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getMonthlyRevenue = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? queryKey[2] : "",
                        tDate: queryKey[3] ? queryKey[3] : "",
                    },
                };
                url = "".concat(IP).concat(getAPIMap("getMonthlyRevenue"));
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getAcctOverview = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                    // startDate: queryKey[2] ? queryKey[2].split("T")[0] : "",
                    // endDate: queryKey[3] ? queryKey[3].split("T")[0] : "",
                    },
                };
                url = "".concat(IP).concat(getAPIMap("getAcctOverview"));
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getAllRcsPostbackData = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, selectedCallOption, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                selectedCallOption = queryKey[4] ? "&actionType=".concat(queryKey[4]) : "";
                url = IP +
                    getAPIMap("getRcsPostbackData") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate).concat(selectedCallOption) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getSummarySmsRevenueData = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getSummarySmsRevenueData") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getAgentsOverviewForRCS = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "startDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "endDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getAgentsOverviewForRCS") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getEmailVolPanelData = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, fDate, tDate, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                };
                fDate = queryKey[2] ? "fDate=".concat(queryKey[2]) : "";
                tDate = queryKey[3] ? "tDate=".concat(queryKey[3]) : "";
                url = IP +
                    getAPIMap("getEmailVolPanelData") +
                    "".concat(fDate && tDate ? "?".concat(fDate, "&").concat(tDate) : "");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getWaRevenueByMonth = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
                        tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
                        timeZone: getTimeZoneInHours().replace("%2B", "+"),
                        // category: "m_ctg",
                        timeRange: queryKey[4],
                    },
                };
                url = IP + getAPIMap("getWhatsAppRevenueData");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getSmsRevenueByMonth = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
                        tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
                        timeZone: getTimeZoneInHours().replace("%2B", "+"),
                        type: "trend",
                        timeRange: queryKey[4],
                    },
                };
                url = IP + getAPIMap("getSummarySmsRevenueData");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getEmailRevenueByMonth = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
                        tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
                        // timeZone: getTimeZoneInHours().replace("%2B", "+"),
                        timeRange: queryKey[4],
                        type: "trend",
                        // category: "m_ctg",
                    },
                };
                url = IP + getAPIMap("getRevenueTrendEmail");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getRcsRevenueByMonth = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var config, url, response;
    var queryKey = _b.queryKey;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                config = {
                    headers: {
                        Authorization: "Bearer ".concat(queryKey[1]),
                    },
                    params: {
                        fDate: queryKey[2] ? customDateStartUTCTimeZoneZ(queryKey[2]) : "",
                        tDate: queryKey[3] ? customDateEndUTCTimeZoneZ(queryKey[3]) : "",
                        // timeZone: getTimeZoneInHours().replace("%2B", "+"),
                        // type: "trend",
                        timeRange: queryKey[4],
                    },
                };
                url = IP + getAPIMap("getRcsRevenueByDays");
                return [4 /*yield*/, axios.get(url, config)];
            case 1:
                response = _c.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export { getPerformancePie, getInterfacePie, getSummaryPanel, getAllEmailVolPanel, getEmailVolumetricsPanel, getVolumetricsPanel, getStatusTrendGraph, getNumbersPanel, getNumberPanel, getSenderPie, getCampaignRevenue, getAllEmailCampaignRevenue, getTopPackages, getTopEnterprises, getNumberInventoryStatusPanel, getNumberConfigurationPanel, getCampaignsPanel, getCampaignCallsPanel, getSummaryRevenue, getRevenueTrendEmail, getEmailMetrics, getAccountCount, getUsersCount, getVolumetricsPanelForOutbound, getVolumetricsPanelForInbound, getMessageTemplatePie, getEmailTemplatePie, getTopEnterprisesForEmail, getTopPackagesForEmail, getEmailScheduleType, getSchedulingTypePie, getTPSConsumption, getEmailCampaigns, getSmsCampaignPanel, getEmailRevenueTrend, getEmailStatusTrend, getWhatsAppCampaigns, getWhatsAppCampaignMessage, getWhatsAppTopCampaigns, getWhatsAppMessageType, getWhatsAppTemplates, getWhatsAppRevenueData, getWhatsAppCampaignRevenueData, getWhatsAppTemplateTypes, getWhatsAppScheduleType, getSummaryRevenueForVoice, getCampaignRevenueForVoice, getTopEnterprisesforVoice, getTopPackagesForVoice, getConcurrentCalls, getWhatsAppMessageTypeTrend, getWhatsAppRevenueTrend, getWhatsAppStatusTrend, getWhatsAppTotalRevenue, getTotalCampaignsCountForVoice, getTotalCampaignsCountForVoiceForApiHits, getRevenueDataForVoice, getRevenueTrendDataForVoice, getApiCallsPanel, getVoiceVolumetricsPanel, getWASummaryPanel, getWhatsAppInboundSummary, getAllRcsCampaignRevenue, getAllRcsTotalRevenue, getAllRcsScheduledCampaign, getAllRcsCampaignStatus, getAllRcsMessageType, getAllRcsSummarypanel, getTemplateDistribution, getWAABusinessNumCounter, getWhatsappTemplateList, getWAATemplateAnalyticsApi, };
